import { compact } from 'lodash-es';
export let ContactIntegrationType = /*#__PURE__*/function (ContactIntegrationType) {
  ContactIntegrationType["Qbo"] = "qbo";
  ContactIntegrationType["Xero"] = "xero";
  return ContactIntegrationType;
}({});
export class ContactIntegrationsModel {
  static fromDTO(contactIntegrations) {
    if (!contactIntegrations) return new ContactIntegrationsModel({});
    let qbo = undefined;
    let xero = undefined;
    contactIntegrations.forEach(integration => {
      if (integration.type === ContactIntegrationType.Qbo) {
        qbo = QboContactIntegrationModel.fromDTO(integration);
      } else if (integration.type === ContactIntegrationType.Xero) {
        xero = XeroContactIntegrationModel.fromDTO(integration);
      }
    });
    return new ContactIntegrationsModel({
      qbo,
      xero
    });
  }
  static toDTO(contactIntegrations) {
    var _contactIntegrations$, _contactIntegrations$2;
    const qboIntegrations = (_contactIntegrations$ = contactIntegrations.qbo) === null || _contactIntegrations$ === void 0 ? void 0 : _contactIntegrations$.toJSON();
    const xeroIntegrations = (_contactIntegrations$2 = contactIntegrations.xero) === null || _contactIntegrations$2 === void 0 ? void 0 : _contactIntegrations$2.toJSON();
    return [...(Array.isArray(qboIntegrations) ? qboIntegrations : [qboIntegrations]), ...(Array.isArray(xeroIntegrations) ? xeroIntegrations : [xeroIntegrations])].filter(integration => integration != null);
  }
  constructor(data) {
    this.qbo = data.qbo;
    this.xero = data.xero;
  }
  toJSON() {
    var _this$qbo, _this$xero;
    const json = compact([(_this$qbo = this.qbo) === null || _this$qbo === void 0 ? void 0 : _this$qbo.toJSON(), (_this$xero = this.xero) === null || _this$xero === void 0 ? void 0 : _this$xero.toJSON()]);
    return json.length ? json : undefined;
  }
  hasIntegrations() {
    return !!(this.qbo || this.xero);
  }
  xeroIntegratedId() {
    return this.xero ? this.xero.integratedId() : null;
  }
  qboIntegratedId() {
    return this.qbo ? this.qbo.integratedId() : null;
  }
  setQboIntegratedId(integratedId) {
    const qbo = this.qbo ? this.qbo.setIntegratedId(integratedId) : integratedId != null ? new QboContactIntegrationModel(integratedId) : undefined;
    return this.cloneWithChanges({
      qbo
    });
  }
  setXeroIntegratedId(integratedId) {
    const xero = this.xero ? this.xero.setIntegratedId(integratedId) : integratedId != null ? new XeroContactIntegrationModel(integratedId) : undefined;
    return this.cloneWithChanges({
      xero
    });
  }
  cloneWithChanges() {
    let changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new ContactIntegrationsModel({
      qbo: 'qbo' in changes ? changes.qbo : this.qbo,
      xero: 'xero' in changes ? changes.xero : this.xero
    });
  }
}
export class XeroContactIntegrationModel {
  static fromDTO(dto) {
    return new XeroContactIntegrationModel(dto.value.integratedId);
  }
  constructor(_integratedId) {
    this._integratedId = _integratedId;
  }
  toJSON() {
    return {
      type: ContactIntegrationType.Xero,
      value: {
        integratedId: this._integratedId
      }
    };
  }
  integratedId() {
    return this._integratedId;
  }
  setIntegratedId(integratedId) {
    return new XeroContactIntegrationModel(integratedId || null);
  }
}
export class QboContactIntegrationModel {
  static fromDTO(dto) {
    return new QboContactIntegrationModel(dto.value.integratedId);
  }
  constructor(_integratedId) {
    this._integratedId = _integratedId;
  }
  toJSON() {
    return {
      type: ContactIntegrationType.Qbo,
      value: {
        integratedId: this._integratedId
      }
    };
  }
  integratedId() {
    return this._integratedId;
  }
  setIntegratedId(integratedId) {
    return new QboContactIntegrationModel(integratedId || null);
  }
}